/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import {
  beneficiaryAccountDetailsById,
  getAllBeneficiaryAccounts,
  updateBeneficiaryAccount,
} from "../../../redux/features/accounts/beneficiaryAccount/index.js";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../utils/configurationProvider.js";
import CategoriesEdit from "../../_utils/AccountCreationComponents/CategoriesEdit/index.jsx";
import PrimaryButton from "../../_utils/CommonButtons/PrimaryButton/index.jsx";
import PrimaryStepper from "../../_utils/CommonSteppers/PrimaryStepper/index.jsx";
import CommonToast from "../../_utils/CommonToast/index.jsx";
import TopNavComponent from "../../_utils/CommonTopNav/TopNavComponent/index.jsx";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank/index.jsx";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import { formatAccountNumber } from "../../_utils/FormatAccountNumber";
import PaginationComponent from "../../_utils/PaginationComponent/index.jsx";
import UniversalRefreshToast from "../../_utils/UniversalRefreshToast/index.jsx";
import Loader from "../../Loader/Index";
import "./index.css";

const UnassignCategories = () => {
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const filterRefMob = useRef(null);
  const containerRef = useRef(null);
  const filterBtnRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const filterBtnRefMob = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const searchBarRefAccmob = useRef(null);
  const scrollContainerRef = useRef(null);
  const searchActionBtnRef = useRef(null);
  const searchBarRefAcc2mob = useRef(null);
  const [inputData] = useState([]);
  const [, setIsOpen] = useState(false);
  const [, setSearchTerm] = useState("");
  const [active, setActive] = useState("");
  const [, setContainerHeight] = useState(0);
  const [selectAllChecked] = useState(false);
  const [, setBeneAccountsCount] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [, setIsStatusSelected] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [categories, setCategories] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [beneAccounts, setBeneAccounts] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("");
  const [searchUserText, setSearchUserText] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showCatePopup, setShowCatePopup] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [categoriesArray, setCategoriesArray] = useState([]);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [defaultCategories, setDefaultCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [beneAccountSelected, setBeneAccountSelected] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [beneAccountsLoading, setBeneAccountsLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [preSelectedCategories, setPreSelectedCategories] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showHeader, setShowHeader] = useState(
    window.innerWidth >= ScreenSizeConfiguration?.mobileScreen,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const { getAllBeneficiaryAccountsLoading, getAllBeneficiaryAccountsData } =
    useSelector((state) => state.beneficiaryAccount);

  const categoriesData = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const hasData =
    Array?.isArray(beneAccounts) &&
    beneAccounts.length > GlobalConfiguration.lengthCheckZero;
  const isEmpty = !beneAccountsLoading && !hasData;

  const toggleSelectAll = () => {
    if (selectedCategories.length === defaultCategories.length) {
      setSelectedCategories([]);
    } else {
      setSelectedCategories(defaultCategories.map((cat) => cat.name));
    }
  };

  const getCategoryNames = (account) =>
    (account?.category_ids ?? []).map((c) => c?.category_name).filter(Boolean);

  useEffect(() => {
    setDefaultCategories(
      categoriesData.filter((category) => category?.active === "Y"),
    );
  }, [categoriesData]);

  const beneEligibleAcct = (beneAccounts) => {
    if (
      Array.isArray(beneAccounts) &&
      beneAccounts?.length > GlobalConfiguration?.lengthCheckZero
    ) {
      const beneAcctEligible = beneAccounts.find(
        (val) =>
          val?.approval_status !== "blocked" &&
          val?.approval_status !== "archived",
      );

      if (beneAcctEligible) {
        setBeneAccountSelected([beneAcctEligible?.id]);
        setSelectedCategories(getCategoryNames(beneAcctEligible));
      }
    }
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const allCategoryIds = defaultCategories.map((c) => c.id).join(",");
  const fetchAccountData = async (currentPage, searchUserText) => {
    const queryParams = {
      page_no: currentPage,
      page_size: pageSize,
      approval_status:
        currentStatus && currentStatus !== "all"
          ? [currentStatus]
          : ["approved", "pending", "rejected"],
      search_string: searchUserText ? searchUserText : undefined,
      category_ids: Array.isArray(allCategoryIds)
        ? allCategoryIds
        : [allCategoryIds],
      // category_ids: allCategoryIds,
    };

    setBeneAccountsLoading(true);

    try {
      const response = await dispatch(getAllBeneficiaryAccounts(queryParams));

      if (response?.payload?.status === true) {
        const accounts = response?.payload?.beneficiary_accounts || [];

        const filteredAccounts = accounts.filter(
          (account) =>
            String(account?.all_category_assign || "")
              .trim()
              .toUpperCase() === "Y",
        );
        console.log(response?.payload?.total_count, "filteredAccounts");
        setBeneAccounts(filteredAccounts);
        setBeneAccountsCount(filteredAccounts.length);
        beneEligibleAcct(filteredAccounts);
      } else {
        setBeneAccounts([]);
        setBeneAccountsCount(0);
        beneEligibleAcct([]);
      }
    } catch (error) {
      console.error(error);
      setBeneAccounts([]);
      setBeneAccountsCount(0);
      beneEligibleAcct([]);
    } finally {
      setBeneAccountsLoading(false);
    }
  };

  useEffect(() => {
    if (
      !defaultCategories ||
      defaultCategories.length === GlobalConfiguration?.lengthCheckZero
    ) {
      return;
    }

    if (getAllBeneficiaryAccountsLoading) return;

    const categoryNames = defaultCategories.map((category) => category.name);

    setCategoriesArray(categoryNames);

    fetchAccountData(currentPage, searchUserText);
  }, [defaultCategories, currentPage, currentStatus, searchUserText, pageSize]);

  useEffect(() => {
    beneEligibleAcct(beneAccounts);
  }, [beneAccounts]);

  useEffect(() => {
    if (
      Array.isArray(defaultCategories) &&
      selectedCategories.length > GlobalConfiguration?.lengthCheckZero
    ) {
      const preSelectedCategories = defaultCategories.filter((category) =>
        selectedCategories.includes(category.name),
      );
      setPreSelectedCategories(preSelectedCategories);
    }
  }, [defaultCategories]);

  const nonPreSelectedCategories = defaultCategories.filter(
    (category) =>
      !preSelectedCategories.some(
        (selectedCat) => selectedCat.id === category.id,
      ),
  );

  const sortedCategories = [
    ...preSelectedCategories,
    ...nonPreSelectedCategories,
  ];

  const handleCategorySelect = (categoryId) => {
    const category = defaultCategories.find((cat) => cat.id === categoryId);
    if (!category) return;

    setSelectedCategories((prev) =>
      prev.includes(category.name)
        ? prev.filter((name) => name !== category.name)
        : [...prev, category.name],
    );
  };

  const handleClickAccountCard = async (id) => {
    setBeneAccountSelected([id]);

    const response = await dispatch(beneficiaryAccountDetailsById({ id }));

    if (response?.payload?.status === true) {
      const account = response?.payload?.beneficiary_accounts?.[0];
      setSelectedCategories(getCategoryNames(account));
    }
  };

  const handleUpdateAccount = async (id) => {
    if (
      services?.includes("Admin") ||
      (services?.includes("BVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("BUAccount"))
    ) {
      UniversalRefreshToast("unassignCate");
      if (beneAccountSelected?.length > GlobalConfiguration?.lengthCheckZero) {
        const selectedCategoryIds = defaultCategories
          .filter((c) => selectedCategories.includes(c.name))
          .map((c) => c.id);
        const response = await dispatch(
          updateBeneficiaryAccount({
            id: id,
            category_ids: selectedCategoryIds,
          }),
        );

        if (response?.payload?.status === true) {
          CommonToast({
            text: "Categories Unassigned Succesfully",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          setShowCatePopup(false);
          setActiveStep(0);
          setCurrentPage(1);
          fetchAccountData(currentPage, searchUserText);
        }
      }
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, BVAccount, PLogin, BUAccount",
        },
      });
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--text-primary)";
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      const height = containerRef.current.offsetHeight;
      setContainerHeight(height);
    }
  }, [showSearchBar]);

  const handleClickOutside = (event) => {
    const clickedOnWebSearch =
      searchBarRefAcc.current?.contains(event.target) ||
      searchBarRefAcc2.current?.contains(event.target) ||
      searchActionBtnRef.current?.contains(event.target);

    const clickedOnMobSearch =
      searchBarRefAccmob?.current?.contains(event.target) ||
      searchBarRefAcc2mob?.current?.contains(event.target);

    if (!clickedOnWebSearch && !clickedOnMobSearch) {
      setShowSearchBar(false);
    }

    const clickedOnWebFilterBtn =
      filterBtnRef.current?.contains(event.target) ||
      filterRef.current?.contains(event.target);

    const clickedOnMobFilterBtn =
      filterBtnRefMob.current?.contains(event.target) ||
      filterRefMob.current?.contains(event.target);

    if (!clickedOnWebFilterBtn && !clickedOnMobFilterBtn) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const isDefaultState =
    (!currentStatus || currentStatus === "all") &&
    searchUserText?.length === GlobalConfiguration?.lengthCheckZero;

  const dataArray = [
    {
      stepperText: "Select Account",
      nextText: "Next",
      previousText: "Back",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextIsEnabled:
        !beneAccountsLoading &&
        Array.isArray(beneAccounts) &&
        beneAccounts.length > GlobalConfiguration?.lengthCheckZero &&
        Array.isArray(beneAccountSelected) &&
        beneAccountSelected.length > GlobalConfiguration?.lengthCheckZero,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-secondary)",
    },

    {
      stepperText: "Select Category",
      nextText: "Update",
      previousText: "Back",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextIsEnabled:
        Array.isArray(selectedCategories) &&
        selectedCategories.length > GlobalConfiguration?.lengthCheckZero &&
        !(
          selectedCategories.includes("all") ||
          (categoriesArray?.length > GlobalConfiguration?.lengthCheckZero &&
            categoriesArray.every((item) => selectedCategories.includes(item)))
        ) &&
        !beneAccountsLoading,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextLoaderNeeded: true,
      nextbeneAccountsLoading: beneAccountsLoading,
    },
  ];
  const handleForward = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      setShowCatePopup(true);
      handleClickAccountCard(beneAccountSelected?.[0]);
      setActiveStep(1);
    } else if (activeStep === GlobalConfiguration?.lengthCheckOne) {
      handleUpdateAccount(beneAccountSelected?.[0]);
    }
  };

  const handleBackward = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckOne) {
      setShowCatePopup(false);
      setActiveStep(0);
    } else {
      navigate("/home");
    }
  };

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  useEffect(() => {
    setTempStatus(currentStatus);
  }, [currentStatus]);

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const onResize = () =>
      setShowHeader(window.innerWidth >= ScreenSizeConfiguration?.mobileScreen);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      <div className={`flex flex-col h-screen overflow-hidden `}>
        {!beneAccountsLoading &&
          beneAccounts?.length > GlobalConfiguration?.lengthCheckZero && (
            <div
              className={`${activeStep === GlobalConfiguration?.lengthCheckOne ? "Qsmd:block hidden" : "block"}
                fixed w-full bottom-bottom-base rounded-none h-pagination-height bg-primary-card ${showInnerSearchBar ? "z-z-index-overlay" : "z-z-index-dropdown"}`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={getAllBeneficiaryAccountsData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={setIsOpen}
              />
            </div>
          )}

        {!beneAccountsLoading &&
          beneAccounts?.length > GlobalConfiguration?.lengthCheckZero && (
            <div
              className={`Qsmd:hidden block fixed w-full bg-primary-card rounded-t-border-radius-md min-h-[calc(var(--day-date-card-height)+var(--dashed-line))] ${activeStep === GlobalConfiguration?.lengthCheckOne ? "bottom-bottom-base" : "bottom-unassign-bottom-md"} z-z-index-header`}
            >
              {showInnerSearchBar && (
                <div className="absolute Qsmd:hidden block bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              {/* <div className="absolute bottom-unassign-bottom-md"> */}
              <PrimaryStepper
                activeStep={activeStep}
                handleForwardAction={handleForward}
                handleBackwardAction={handleBackward}
                dataArray={dataArray}
              />
              {/* </div> */}
            </div>
          )}

        <div
          className={`bg-primary-bg flex flex-col flex-1 h-screen overflow-hidden`}
        >
          <div className="w-full z-z-index-header">
            <div className="Qsmd:h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
            <TopNavComponent
              isFormattingNotRequired={true}
              topNavHeader={!showHeader ? "Unassign categories" : undefined}
              topNavSubText={
                activeStep === GlobalConfiguration?.lengthCheckZero &&
                !showHeader
                  ? "Select account"
                  : undefined
              }
              topNavCtaBtn1Needed={false}
              topNavCtaBtn2Needed={false}
              filteredSearchProps={
                activeStep === GlobalConfiguration?.lengthCheckZero ||
                showHeader
                  ? {
                      setShowInnerSearchBar,
                      showSearchBar,
                      isSearchDisabled: beneAccountsLoading,
                      onSearchInput: handleSearch,
                      searchText: searchUserTextDebounce,
                      searchPlaceholder: "Search beneficiary account",
                      filterPlaceholder:
                        "Search by account ID/ name/ contact number/ email ID",
                      filterItems: [
                        {
                          name: "Search",
                          isMulti: false,
                          value: searchUserText,
                          setValue: (val) => {
                            setCurrentPage(1);
                            setSearchUserText(val);
                            setSearchTerm(val);
                          },
                          isDropdown: false,
                          isDisabled: false,
                        },
                      ],
                      filters: [
                        {
                          name: "Approval status",
                          filterType: "dropdown",
                          variant: "single",
                          value: tempStatus,
                          options: ["approved", "pending", "rejected"],
                          dropdownPlaceHolder: "Select Status",
                          isDisabled: false,
                          statusPop: true,
                          handleChange: (value) => {
                            setCurrentPage(1);
                            setTempStatus(value);
                            setCurrentStatus(value);
                          },
                        },
                      ],
                      isFilterClearAllDisabled: !(
                        currentStatus?.length >
                          GlobalConfiguration?.lengthCheckZero ||
                        beneAccountsLoading
                      ),
                      inputData,
                      active,
                      setActive,
                      loading: beneAccountsLoading,
                      setLoading: () => {},
                      isShowFilter: true,
                      isShowSortBy: false,
                    }
                  : undefined
              }
              topNavCtaBtn2Props={
                showHeader
                  ? {
                      inActiveVariantNeeded: true,
                      btnText: "Update",
                      btnType: "button",
                      enabledBgColor: "var(--positive-act)",
                      enabledTextColor: "var(--text-primary)",
                      disabledBgColor: "var(--text-disabled)",
                      disabledTextColor: "var(--text-primary)",
                      isDisabled:
                        beneAccountsLoading ||
                        beneAccounts.length ===
                          GlobalConfiguration?.lengthCheckZero ||
                        selectedCategories?.length ===
                          GlobalConfiguration?.lengthCheckZero ||
                        categoriesArray.every((item) =>
                          selectedCategories.includes(item),
                        ),
                      hoverOption: "white",
                      handleFunction: () => {
                        if (
                          beneAccounts.length ===
                            GlobalConfiguration?.lengthCheckZero ||
                          selectedCategories?.length ===
                            GlobalConfiguration?.lengthCheckZero ||
                          categoriesArray.every((item) =>
                            selectedCategories.includes(item),
                          )
                        ) {
                          return;
                        }

                        handleUpdateAccount(beneAccountSelected?.[0]);
                      },
                    }
                  : undefined
              }
            />
          </div>
          <div className="beneTxnViewAll_middle_section_container mx-auto webViewRejectAll"></div>

          {beneAccountsLoading ? (
            <div className="flex flex-1 items-center justify-center">
              <Loader />
            </div>
          ) : isEmpty ? (
            <div className="no-account-image-div h-full flex items-center justify-center relative z-z-index-content">
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none" />
              )}
              <div
                className={
                  isSidebarOpen
                    ? "h-[100vh] w-width-full bg-PopUp-BackDrop opacity-dark-opacity flex flex-col items-center justify-center"
                    : "flex flex-col items-center justify-center m-auto overflow-y-scroll"
                }
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={`w-graphic-width-md h-graphic-rectangle-height-md ${
                    isSidebarOpen
                      ? "opacity-light-opacity"
                      : "opacity-base-opacity"
                  }`}
                />

                <p
                  className={
                    isSidebarOpen
                      ? "no-owneraccount-text-opacity"
                      : "text-text-primary opacity-base-opacity text-font-sm text-center py-padding-sm"
                  }
                >
                  No accounts found with all assigned categories.
                </p>

                {!isSidebarOpen && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-act)"
                    btnText={
                      isDefaultState ? "Home dashboard" : "Clear parameters"
                    }
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (isDefaultState) {
                        navigate("/home");
                        return;
                      }

                      setSearchUserText("");
                      setSearchTerm("");
                      setCurrentStatus("");
                      setTempStatus("");
                      setIsStatusSelected(false);
                      setCurrentPage(1);
                    }}
                    hoverOption="white"
                  />
                )}
              </div>
            </div>
          ) : (
            <div
              ref={scrollContainerRef}
              className="flex Qsmd:flex-row flex-col flex-1 bg-primary-card overflow-y-hidden relative z-z-index-content"
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none" />
              )}

              <div
                className={`Qsmd:mb-margin-base h-height-full flex justify-end min-h-0 pb-pagination-height w-full Qsmd:w-width-sm ${showInnerSearchBar && "pointer-events-none"} ${
                  isSidebarOpen
                    ? "bg-PopUp-BackDrop opacity-light-opacity overflow-hidden"
                    : "bg-primary-card overflow-y-hidden z-z-index-content"
                }  ${activeStep === GlobalConfiguration?.lengthCheckZero ? "block" : "hidden Qsmd:block"}`}
              >
                <div
                  style={{
                    scrollPaddingTop: "var(--padding-md)",
                    scrollPaddingBottom: "var(--padding-md)",
                  }}
                  className=" h-full Qsmd:w-[unset] w-full overflow-y-auto"
                >
                  <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-sm">
                    {beneAccounts.map((val, index) => {
                      return (
                        <CardContainer
                          key={index}
                          context={val}
                          hoverHeight={
                            GlobalConfiguration?.reimbursementAccountCardHoverHeight
                          }
                          filterRef={scrollContainerRef}
                          index={index}
                          cardBgColor="primary-nav"
                          isSelected={
                            Array.isArray(beneAccountSelected) &&
                            beneAccountSelected.includes(val.id)
                          }
                          minHeight={"var(--min-card-height)"}
                          isDisabled={isSidebarOpen ? true : false}
                          onClickHandler={() => {
                            if (!isSidebarOpen) {
                              setShowCatePopup(!showCatePopup);
                              handleClickAccountCard(val?.id);
                            }
                          }}
                        >
                          <card-body>
                            <TextWithIcon
                              type="text"
                              fontWeight="semibold"
                              text={val.name
                                ?.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" ")}
                              textColor={
                                val.approval_status === "denied"
                                  ? getStatusColor("rejected")
                                  : getStatusColor(val.approval_status)
                              }
                              iconComponentArray={
                                Array.isArray(beneAccountSelected) &&
                                beneAccountSelected.includes(val.id)
                                  ? [
                                      {
                                        icon: ICONS?.SELECTED_WITH_GREEN_CIRCLE,
                                        isDisabled: false,
                                      },
                                    ]
                                  : []
                              }
                            />

                            <TextWithBank
                              text={formatAccountNumber(val.bank_acc_no)}
                              subText="Account number"
                              fontWeight="normal"
                              textColor="var(--text-primary)"
                              ifscCode={val?.ifsc_code}
                            />
                          </card-body>
                          <card-hover>
                            <TextWithIcon
                              text={val?.approval_status}
                              subText={"Account status"}
                              textCase={"capitalize"}
                              fontWeight={"semibold"}
                              textColor={getStatusColor(val?.approval_status)}
                            />
                            <TextWithIcon
                              text={
                                val?.labels?.join(", ") || "No labels assigned"
                              }
                              iconComponentArray={[{ icon: ICONS.LABEL }]}
                              fontWeight={"normal"}
                              textColor={"var(--text-primary)"}
                            />
                          </card-hover>
                        </CardContainer>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div
                className={`flex flex-1 bg-primary-bg justify-start w-full Qsmd:w-width-lg Qsmd:flex ${activeStep === GlobalConfiguration?.lengthCheckOne ? "block" : "hidden"} ${isSidebarOpen ? "overflow-hidden pointer-events-none" : "overflow-y-auto"}`}
              >
                <div className="p-padding-md Qsmd:w-[unset] w-full">
                  <CategoriesEdit
                    sortedCategories={sortedCategories}
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                    selectAllChecked={selectAllChecked}
                    toggleSelectAll={toggleSelectAll}
                    handleCategorySelect={handleCategorySelect}
                    Title="Categories"
                    SubTitle="Restrict the number of categories, as selecting all is not recommended."
                    TitleFontcolor="text-primary"
                    TextSize="font-md"
                    SubTitleFontcolor="text-secondary"
                    SubTitleTextSize="font-xs"
                    TitleFontWeight="semibold"
                    SubTitleFontWeight="normal"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {!beneAccountsLoading &&
          beneAccounts.length > GlobalConfiguration?.lengthCheckZero && (
            <div
              className={`flex flex-shrink-0 bg-primary-card ${activeStep === GlobalConfiguration?.lengthCheckOne ? "h-pagination-height" : "h-[var(--graphic-width-sm)] Qsmd:h-pagination-height"}`}
            ></div>
          )}
      </div>
    </>
  );
};

export default UnassignCategories;
